export const readSessionValue = (key: string): string | null => {
  if (typeof window === "undefined") return null;

  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const writeSessionValue = (key: string, value: string): void => {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    return;
  }
};

export const removeSessionValue = (key: string): void => {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.removeItem(key);
  } catch {
    return;
  }
};
